const getComputedStyleValue = (property: string): string => {
  if (typeof window === 'undefined' || !document?.documentElement) {
    return '';
  }

  const rootVars = window.getComputedStyle(document.documentElement);
  return rootVars.getPropertyValue(property).trim();
};

export const MAIN_THEME = {
  color: {
    // System Colors
    red: getComputedStyleValue('--red'),
    green: getComputedStyleValue('--green'),
    orange: getComputedStyleValue('--orange'),
    black: getComputedStyleValue('--black'),
    black25: getComputedStyleValue('--black25'),
    black47: getComputedStyleValue('--black47'),
    white65: getComputedStyleValue('--white65'),
    white86: getComputedStyleValue('--white86'),
    white92: getComputedStyleValue('--white92'),
    white98: getComputedStyleValue('--white98'),
    white: getComputedStyleValue('--white'),
    lightGray: getComputedStyleValue('--lightGray'),

    // Special Widgets Colors
    blue: getComputedStyleValue('--blue'),
    darkBlue: getComputedStyleValue('--darkBlue'),
    darkRed: getComputedStyleValue('--darkRed'),
    currencyGreen: getComputedStyleValue('--currencyGreen'),
    currencyLightGreen: getComputedStyleValue('--currencyLightGreen'),
    currencyBlue: getComputedStyleValue('--currencyBlue'),
    currencyLightBlue: getComputedStyleValue('--currencyLightBlue'),
    purple: getComputedStyleValue('--purple'),
    yellow: getComputedStyleValue('--yellow')
  },
  font: {
    regular: getComputedStyleValue('--primaryFontRegular'),
    medium: getComputedStyleValue('--primaryFontMedium'),
    bold: getComputedStyleValue('--primaryFontBold')
  },
  fontSize: {
    // rem is used to ensure that the font size is responsive
    // this should be used for text only
    xs: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    rg: '1rem', // 16px
    md: '1.125rem', // 18px
    lg: '1.25rem', // 20px
    xl: '1.5rem', // 24px
    xxl: '1.75rem' // 28px
  },
  size: {
    // px is used to ensure that the size is fixed
    // this should be used for padding, margin, width, height, etc.
    xs: '12px',
    sm: '14px',
    rg: '16px',
    md: '24px',
    lg: '32px',
    xl: '48px'
  }
};

export const HEADER_HEIGHT = 60;
